import { Injectable } from '@angular/core';

import { PaymentMethod } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class PaymentMethodService extends TmsWebBaseEditService<PaymentMethod, PaymentMethod> {
  constructor() {
    super('PaymentMethod', $localize`Payment Method`);
  }
}
